export class RotationUtil {
  static SLASH: string = '/';
  static EQUAL: string = '=';

  static RF: string = 'rf';
  static ROTATE_EQUAL: string = RotationUtil.RF + RotationUtil.EQUAL;
  static ROTATE_CLOCKWISE: string = 'cw';
  static ROTATE_COUNTERCLOCKWISE: string = 'ccw';
  static ROTATE_UPSIDEDOWN: string = 'ud';

  private static normalizeRotation(s: string[]): string | null {
    if (s.length > 1) {
      const firstValue = s.pop();
      const secondValue = s.pop();

      if (typeof firstValue === 'string' && typeof secondValue === 'string') {
        const nxt: string = this.mergeRotation(firstValue, secondValue);
        if (nxt.trim() !== '') {
          s.push(nxt);
        }
      }

      return this.normalizeRotation(s);
    } else if (s.length === 1) {
      return s.pop() as string;
    } else {
      return null;
    }
  }

  private static mergeRotation(r: string, r1: string): string {
    if (
      RotationUtil.ROTATE_CLOCKWISE === r &&
      RotationUtil.ROTATE_CLOCKWISE === r1
    ) {
      return RotationUtil.ROTATE_UPSIDEDOWN;
    } else if (
      RotationUtil.ROTATE_COUNTERCLOCKWISE === r &&
      RotationUtil.ROTATE_COUNTERCLOCKWISE === r1
    ) {
      return RotationUtil.ROTATE_UPSIDEDOWN;
    } else if (
      (RotationUtil.ROTATE_COUNTERCLOCKWISE === r &&
        RotationUtil.ROTATE_CLOCKWISE === r1) ||
      (RotationUtil.ROTATE_CLOCKWISE === r &&
        RotationUtil.ROTATE_COUNTERCLOCKWISE === r1)
    ) {
      return '';
    } else if (
      (RotationUtil.ROTATE_UPSIDEDOWN === r &&
        RotationUtil.ROTATE_CLOCKWISE === r1) ||
      (RotationUtil.ROTATE_CLOCKWISE === r &&
        RotationUtil.ROTATE_UPSIDEDOWN === r1)
    ) {
      return RotationUtil.ROTATE_COUNTERCLOCKWISE;
    } else if (
      (RotationUtil.ROTATE_UPSIDEDOWN === r &&
        RotationUtil.ROTATE_COUNTERCLOCKWISE === r1) ||
      (RotationUtil.ROTATE_COUNTERCLOCKWISE === r &&
        RotationUtil.ROTATE_UPSIDEDOWN === r1)
    ) {
      return RotationUtil.ROTATE_CLOCKWISE;
    } else if (
      RotationUtil.ROTATE_UPSIDEDOWN === r &&
      RotationUtil.ROTATE_UPSIDEDOWN === r1
    ) {
      return '';
    } else {
      throw new Error('Invalid rotations! r=' + r + ', r1=' + r1);
    }
  }

  private static handleResultingRotation(
    sb: string[],
    rotation: string[],
  ): void {
    const rotateEqualSlash: string =
      RotationUtil.ROTATE_EQUAL + RotationUtil.SLASH;
    if (rotation.length !== 0) {
      const finalRotation: string | null = this.normalizeRotation(rotation);
      const rotateEqualFinalRotationSlash: string =
        finalRotation !== null ? RotationUtil.ROTATE_EQUAL + finalRotation : '';
      if (finalRotation !== null && finalRotation.trim() !== '') {
        const rotationIndex: number = sb.indexOf(rotateEqualSlash);
        sb.splice(rotationIndex, 1, rotateEqualFinalRotationSlash);
      } else {
        const rotationIndex: number = sb.indexOf(rotateEqualSlash);
        sb.splice(rotationIndex, 1);
      }
    }
  }

  private static handleRotate(
    rotateValue: string,
    sb: string[],
    srotation: string[],
    rotateCounter: number,
  ): number {
    srotation.push(rotateValue);
    if (RotationUtil.ROTATE_CLOCKWISE === rotateValue) {
      rotateCounter = (rotateCounter + 1) % 4;
    } else if (RotationUtil.ROTATE_UPSIDEDOWN === rotateValue) {
      rotateCounter = (rotateCounter + 2) % 4;
    } else if (RotationUtil.ROTATE_COUNTERCLOCKWISE === rotateValue) {
      rotateCounter = (rotateCounter + 3) % 4;
    }
    const rotateEqualSlash: string =
      RotationUtil.ROTATE_EQUAL + RotationUtil.SLASH;
    const index: number = sb.indexOf(rotateEqualSlash);
    if (index !== -1) {
      sb.splice(index, 1);
    }
    sb.push(rotateEqualSlash);
    return rotateCounter;
  }

  public static reduceJournal(journal: string): string {
    const srotation: string[] = [];
    let rotateCounter: number = 0;
    if (!journal || journal.trim() === '') return journal;
    const jrls: string[] = journal.split('/');
    const sb: string[] = [];
    for (const singleJrl of jrls) {
      if (singleJrl && singleJrl.trim() !== '') {
        const j: string[] = singleJrl.split('=');
        if (j.length > 1) {
          if (
            RotationUtil.RF === j[0] &&
            (RotationUtil.ROTATE_COUNTERCLOCKWISE === j[1] ||
              RotationUtil.ROTATE_CLOCKWISE === j[1] ||
              RotationUtil.ROTATE_UPSIDEDOWN === j[1])
          ) {
            rotateCounter = this.handleRotate(
              j[1],
              sb,
              srotation,
              rotateCounter,
            );
          } else {
            sb.push(singleJrl + RotationUtil.SLASH);
          }
        }
      }
    }

    this.handleResultingRotation(sb, srotation);
    return sb.join('');
  }
}
